// Module H2 notifications (interface) : points d'intégration dans la coquille et le routeur.

import { createElement } from 'react';
import { PageNotifications } from './Notifications';

export { ClocheNotifications, PageNotifications, PreferencesParTypeEtCanal } from './Notifications';
export {
  FournisseurTempsReel,
  useEtatFlux,
  intervalleSecours,
  LIBELLES_ETAT_FLUX,
  type EtatFlux,
} from './tempsReel';

export const inscription = {
  nom: 'notifications',
  routes: [{ chemin: '/notifications', element: createElement(PageNotifications) }],
  /** Éléments de la barre supérieure (coquille) : la cloche et son panneau. */
  barre: ['ClocheNotifications'],
  /** Fournisseur à placer autour du contenu de la coquille (un seul flux temps réel par onglet). */
  fournisseur: 'FournisseurTempsReel',
  pages: [
    {
      motif: /^\/notifications$/,
      libelle: 'Notifications',
      parent: '/',
      aide: 'Centre de notifications : historique, lecture, préférences par type et par canal. Le courriel et le SMS ne sont proposés que s’ils sont configurés sur le serveur ; sinon seules les notifications dans la plateforme sont actives.',
    },
  ],
} as const;
